
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, LinearProgress, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { useState } from "react"
import useDebounce from "../../../lib/useDebounce";
import { useQuery } from "react-query";
import axiosClient from "../../../lib/axios";
import { PragaReceituario } from "../../../types/api/comercial/pesquisar-cultura-praga-receituario";
import LoadingApiQuery from "../../LoadingApiQuery";
import SearchIcon from '@mui/icons-material/Search';

export default function DialogSelectPraga({
    open,
    cultura_id,
    agrotoxico_id,
    handleClose,
    handleSubmit
}: DialogSelectPragaProps) {

    const [selected, setSelected] = useState<PragaReceituario | null>(null)
    const [keyword, setKeyword] = useState<string>("")

    //queries e mutations
    const debouncedKeyword = useDebounce(keyword)
    const { data, isFetching, isLoading } = useQuery({
        queryKey: ['/receituario-agronomico/pragas/pesquisar-praga-relacionada', debouncedKeyword, cultura_id, agrotoxico_id],
        queryFn: () => axiosClient.get("/receituario-agronomico/pragas/pesquisar-praga-relacionada", {
            params: {
                pesquisar: debouncedKeyword,
                cultura_id,
                agrotoxico_id
            }
        }),
        retry: false,
        keepPreviousData: true,
        cacheTime: 0
    });
    const dadosPraga: PragaReceituario[] = data?.data || []

    //funções manipuladoras
    const handleConfirm = () => {
        if (selected) handleSubmit(selected)
    }

    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll="body"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                Selecionar praga
            </DialogTitle>

            <DialogContent>
                <Box py={2}>
                    <TextField
                        fullWidth
                        value={keyword}
                        label="Pesquisar"
                        onChange={({ target }) => setKeyword(target.value)}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }
                        }}
                    />

                    {isLoading && <LoadingApiQuery extraParams={{ height: 400, my: 1, alignItems: "center" }} />}
                    <Box mt={1}>{(isFetching && data) && <LinearProgress />}</Box>
                    {
                        (!isLoading && data) &&
                        <TableContainer
                            sx={{ height: 400, overflow: "auto", mb: 1 }}
                        >

                            <Table size="small" aria-label="a dense table" stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell><b>Nome científico</b></TableCell>
                                        <TableCell><b>Nome popular</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {dadosPraga.map((row) => {
                                        const identificador = row.praga_id.toString()
                                        const radioMarcado = selected?.praga_id === row.praga_id

                                        return (
                                            <TableRow
                                                key={row.praga_id}
                                                sx={{
                                                    cursor: "pointer",
                                                    backgroundColor: radioMarcado ? "#edf7ed" : "unset",
                                                    '&:last-child td, &:last-child th': { border: 0 }
                                                }}
                                                onClick={() => {
                                                    setSelected(row)
                                                }}
                                            >
                                                <TableCell>
                                                    <Radio
                                                        name="radio-buttons"
                                                        checked={radioMarcado}
                                                        slotProps={{ input: { 'aria-label': identificador } }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Typography
                                                        variant="subtitle2"
                                                    >
                                                        {row.nome_cientifico}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography
                                                        variant="subtitle2"
                                                    >
                                                        {row.nome_popular}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    disabled={!selected}
                    variant="contained"
                    onClick={handleConfirm}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogSelectPragaProps {
    open: boolean,
    cultura_id?: number,
    agrotoxico_id: number,
    handleClose: () => void,
    handleSubmit: (arg: PragaReceituario) => void
}
